<template>
  <div class="account-permission section-main__warp">
    <div class="content">
      <div class="permission-content permission-content-left">
        <div class="search-select">
          <div class="title">设备组</div>
          <div class="type-search">
            <el-input
              v-model="treeSearch"
              clearable
              @clear="clearTreeSearch"
              placeholder="请输入名称"
            >
            </el-input>
            <el-select
              v-model="deviceGroupValue"
              style="width: 50%"
              placeholder="请选择类型"
              @change="selectChange"
            >
              <el-option
                v-for="item in deviceGroupOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="tree-container tree-line-style">
          <el-scrollbar class="scroll-bar">
            <el-tree
              v-if="showTree"
              ref="tree"
              class="tree-content"
              :data="treeData"
              :expand-on-click-node="false"
              node-key="id"
              :default-expanded-keys="expandedKeys"
              render-after-expand
              :props="treeProps"
              :highlight-current="true"
              :filter-node-method="filterNode"
              @node-click="nodeClick"
            >
              <template slot-scope="{ node }">
                <element-tree-line
                  :node="node"
                  :showLabelLine="true"
                  :indent="16"
                  class="tree-line"
                >
                  <span class="custom-tree-node" style="display: block">
                    <span style="margin-left: 3px">{{ node.label }}</span>
                  </span>
                </element-tree-line>
              </template>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>
      <div class="permission-content permission-content-right">
        <div class="deviceList">
          <!-- <div>
            <el-button
              type="primary"
              @click="back"
              icon="iconfont icon-iconfontfanhui"
              >{{ $t("account.button.back") }}</el-button
            >
          </div> -->
          <div class="device-search" v-if="opreateType !== '2'">
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <span style="width: 100px"> 设备名称 </span>
              <el-input
                v-model="searchString"
                :placeholder="$t('area.placeholder.name')"
              ></el-input>
            </div>
            <div>
              
              <el-button type="primary" @click="filterText">{{
                $t("area.button.query")
              }}</el-button>
              <el-button type="info" @click="clearSearchDeviceName">{{
                $t("area.button.reset")
              }}</el-button>
              <el-button
                type="primary"
                @click="back"
                style="margin-left:46px"
                icon="iconfont icon-iconfontfanhui"
                >{{ $t("account.button.back") }}</el-button
              >
            </div>
          </div>
          <div class="device">
            <div style="margin-bottom: 16px">
              <el-button
                type="primary"
                v-if="opreateType !== '2'"
                @click="save"
                >{{ $t("account.button.save") }}</el-button
              >
            </div>
            <div style="position: relative; height: calc(100% - 50px)">
              <el-table :data="deviceList" height="100%">
                <el-table-column
                  prop="deviceName"
                  show-overflow-tooltip
                  :label="$t('account.label.deviceName')"
                ></el-table-column>
                <el-table-column
                  prop="deviceTypeLabel"
                  show-overflow-tooltip
                  :filters="deviceMarkList"
                  :filter-method="filterChange"
                  filter-placement="right-start"
                  column-key="deviceTypeLabel"
                  :label="$t('account.label.deviceType')"
                ></el-table-column>
                <el-table-column :label="$t('account.label.showPermission')">
                  <template slot="header" slot-scope="scope">
                    <el-checkbox
                      v-model="scope._self.showAll"
                      :disabled="opreateType === '2' ? true : false"
                      :label="$t('account.label.showPermission')"
                      @change="showChangeAll"
                    ></el-checkbox>
                  </template>
                  <template slot slot-scope="scope">
                    <el-checkbox
                      v-model="scope.row.showPermission"
                      :disabled="opreateType === '2' ? true : false"
                      @change="showChange(scope.row)"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('account.label.operatePermission')">
                  <template slot="header" slot-scope="scope">
                    <el-checkbox
                      v-model="scope._self.controlAll"
                      :disabled="opreateType === '2' ? true : false"
                      :label="$t('account.label.operatePermission')"
                      @change="operateChangeAll"
                    ></el-checkbox>
                  </template>
                  <template slot slot-scope="scope">
                    <el-checkbox
                      v-model="scope.row.operatePermission"
                      :disabled="opreateType === '2' ? true : false"
                      @change="operateChange(scope.row)"
                    ></el-checkbox>
                  </template>
                </el-table-column>
                <template slot="empty">
                  <div class="table-empty">
                    <img src="@/common/assets/images/empty.svg" />
                    <p>{{ $t("base.label.empty") }}</p>
                  </div>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ElementTreeLine from "element-tree-line";
import utils from "$utils";
import { api } from "../api";
import { Dic, Bus, Dates } from "$utils";
export default {
  components: {
    ElementTreeLine,
  },
  watch: {
    treeSearch(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    return {
      title: "",
      visible: false,
      searchString: "",
      treeData: Object.freeze([]),
      deviceList: Object.freeze([]),
      deviceMarkList: [],
      showList: [],
      operateList: [],
      allDeviceList: [],
      controlAll: false,
      showAll: false,
      // 展开的节点id
      expandedKeys: [],
      treeProps: {
        children: "children",
        label: "name",
        isLeaf: "isLeaf",
      },
      // 缓存全量树结构
      cacheTree: [],
      showTree: true,
      // 判断是新增还是修改  1配置 2详情
      opreateType: "1",
      groupCode: "",
      deviceGroupOptions: [
        {
          value: "1",
          label: "人脸闸机",
        },
        {
          value: "4",
          label: "消防",
        },
        {
          value: "10",
          label: "摄像机",
        },
        {
          value: "17",
          label: "车辆道闸",
        },
        {
          value: "18",
          label: "广播",
        },
        {
          value: "20",
          label: "一键求救",
        },
        {
          value: "21",
          label: "电气火灾",
        },
      ],
      deviceGroupValue: "10",
      deviceWorkGroupCode: "",
      treeSearch: "",
      // 左侧树勾选的工作组id集合
      checkTreeIds: [],
    };
  },
  computed: {
    showAll1(val) {
      return this.showAll;
    },
    controlAll1(val) {
      return this.controlAll;
    },
  },
  created() {
    this.account = {};
    this.dicData = {};
    let dicList = utils.Dic.find("SENU087");
    dicList.forEach((item) => {
      this.dicData[item.value + ""] = item.label;
    });
    // 从路由判断 1配置 2详情
    if (this.$route.query) {
      this.opreateType = this.$route.query.type;
      this.groupCode = this.$route.query.code;
    }
    // this.getDetails();
    this.getWorkGroupTree();
  },
  methods: {
    selectChange(val) {
      this.deviceGroupValue = val;
      this.getWorkGroupTree();
      this.deviceList = [];
    },
    //页面初始化时获取工作组树列表
    getWorkGroupTree() {
      const self = this;
      let params = {
        deviceType: this.deviceGroupValue,
      };
      this.$fetch(api.group.queryDeviceWorkGroup, params).then((response) => {
        const result = self.menusDataPro(response.returnObj);
        self.cacheTree = result;
        self.treeData = Object.freeze(result);
        let firstNode = self.treeData[0];
        self.expandedKeys = [firstNode.id];
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(firstNode);
          this.nodeClick(firstNode);
        });
      });
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.deviceWorkGroupCode;
          entity.name = item.deviceWorkGroupName;
          entity.parentCode = item.parentCode;
          entity.deviceWorkGroupCodeList = item.deviceWorkGroupCodeList;
          entity.isLeaf = !item.hasLeaf || !item.deviceWorkGroupChildren;
          if (item.deviceWorkGroupChildren) {
            entity.children = self.menusDataPro(item.deviceWorkGroupChildren);
          }
          result.push(entity);
        });
        return result;
      }
    },
    // 检索树
    filterTree() {
      if (!this.treeSearch) {
        this.showTree = false;
        this.$nextTick(() => {
          this.showTree = true;
        });
        this.getWorkGroupTree();
        return;
      }
      this.$refs.tree.filter(this.treeSearch.trim());
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    //重置
    clearTreeSearch() {
      this.searchString = "";
      this.filterTree();
    },
    // 检索设备列表中的全部设备类型
    filterText() {
      let typeList = this.deviceMarkList.map((r) => r.value);
      this.deviceList = this.allDeviceList.filter((item) => {
        item.showPermission = item.deviceRead === "1";
        item.operatePermission = item.deviceControl === "1";
        item.deviceTypeLabel = this.dicData[item.deviceType];
        if (typeList.indexOf(item.deviceType) === -1) {
          typeList.push(item.deviceType);
          this.deviceMarkList.push({
            text: item.deviceTypeLabel,
            value: item.deviceType,
          });
        }
        return (
          item.deviceName
            .toLowerCase()
            .indexOf(this.searchString.trim().toLowerCase()) > -1
        );
      });
    },

    filterChange(value, row, column) {
      return row["deviceMark"] === value;
    },
    // 节点点击事件
    nodeClick(data) {
      this.$refs.tree.setChecked(data, true);
      this.$nextTick(() => {
        this.checkTreeIds = [data.id];
        this.getDevList();
      });
    },
    // 获取设备列表
    getDevList() {
      this.deviceList = [];
      let params = {
        authGroupCode: this.groupCode,
        deviceName: "",
        deviceType: this.deviceGroupValue,
        deviceWorkGroupCodeList: this.checkTreeIds,
      };
      this.$fetch(api.group.queryDeviceList, params).then((res) => {
        if (res.success) {
          let typeList = this.deviceMarkList.map((r) => r.value);
          this.allDeviceList = res.returnObj;
          this.deviceList = this.allDeviceList.map((item) => {
            this.$set(item, "showPermission", item.deviceRead === "1");
            this.$set(item, "operatePermission", item.deviceControl === "1");
            this.$set(item, "deviceTypeLabel", this.dicData[item.deviceMark]);
            if (typeList.indexOf(item.deviceMark) === -1) {
              typeList.push(item.deviceMark);
              this.deviceMarkList.push({
                text: item.deviceMarkLabel,
                value: item.deviceMark,
              });
            }
            return item;
          });
          this.getAllNum();
        } else {
          this.$message({
            message: res.msgContent,
            type: "error",
          });
        }
      });
    },

    showChangeAll(value) {
      console.log("--showChangeAll-", value);
      this.deviceList.forEach((item) => {
        item.showPermission = value;
        if (!value) {
          item.operatePermission = value;
        }
      });
      if (!value) {
        this.controlAll = value;
      }
    },
    operateChangeAll(val) {
      console.log("--operateChangeAll--", val);
      this.deviceList.forEach((item) => {
        if (val) {
          item.showPermission = val;
        }
        item.operatePermission = val;
      });
      if (val) {
        this.showAll = val;
      }
    },
    showChange(row, value) {
      if (!row.showPermission) {
        row.operatePermission = row.showPermission;
      }
      this.getAllNum();
    },
    operateChange(row, value) {
      if (row.operatePermission) {
        row.showPermission = row.operatePermission;
      }
      this.getAllNum();
      // row.operatePermission = value;
    },
    getAllNum() {
      const operateList = this.deviceList.filter(
        (item) => item.operatePermission
      );
      console.log("---操作权限----", operateList);
      if (
        operateList.length === this.deviceList.length &&
        this.deviceList.length > 0
      ) {
        this.controlAll = true;
      } else {
        this.controlAll = false;
      }
      const showList = this.deviceList.filter((item) => item.showPermission);
      console.log("-----查看权限----", showList);
      if (
        showList.length === this.deviceList.length &&
        this.deviceList.length > 0
      ) {
        this.showAll = true;
      } else {
        this.showAll = false;
      }
    },
    //重置
    clearSearchDeviceName() {
      this.searchString = "";
      this.filterText();
    },
    back() {
      this.$router.push("/authGroup/index")
      // this.$router.back(-1);
    },
    save() {
      // 配置权限组时的逻辑
      if (this.opreateType === "1") {
        const deviceList = this.allDeviceList.map((device) => {
          device.deviceRead = device.showPermission ? 1 : 0;
          device.deviceControl = device.operatePermission ? 1 : 0;
          return {
            deviceId: device.deviceId,
            deviceRead: device.deviceRead,
            deviceControl: device.deviceControl,
          };
        });
        let arr = [];
        deviceList.forEach((item) => {
          if (item.deviceRead !== 0 || item.deviceControl !== 0) {
            arr.push(item);
          }
        });
        let params = {
          authGroupCode: this.groupCode,
          authGroupDeviceList: deviceList,
        };
        // console.log('---params-----', params);
        this.$fetch(api.group.updateAuthGroupAuthority, params).then(
          (response) => {
            if (response && response.success) {
              this.$message.success("配置设备权限成功" || res.msgContent);
            } else {
              this.$message.error(res.msgContent || "配置设备权限失败");
            }
          }
        );
      }
    },
  },
};
</script>

<style lang="scss">
@import "~@src/common/assets/style/mixin";
.account-permission {
  flex-direction: column;
  .content {
    display: flex;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }
  .permission {
    &-content {
      &-left {
        width: 380px;
        @include set_theme_color(background-color, left-menu-bg-color);
        .search-select {
          .title {
            border-left: 4px solid #407aee;
            padding-left: 8px;
            margin: 16px;
          }
          .type-search {
            display: flex;
            margin: 16px;
            height: 28px;
          }
        }
        .scroll-bar {
          height: calc(100% - 0px);
        }
        .tree-container {
          height: calc(100% - 100px);
        }
        .tree-content {
          padding-bottom: 12px;
          .el-tree-node__label {
            display: inline-block;
            max-width: 80%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
        .tree-header {
          position: relative;
          background: #3f629c;
          color: #fff;
          font-weight: bold;
          font-size: 13px;
        }
        .custom-info {
          position: absolute;
          display: inline-block;
          height: 40px;
          line-height: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      &-right {
        height: 100%;
        width: calc(100% - 386px);
        position: relative;
        margin-left: 8px;
        .deviceList {
          flex: 1;
          position: relative;
          height: 100%;
          .device-search {
            display: flex;
            padding: 12px 16px;
            margin: 0px 0 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            @include set_theme_color(background-color, left-menu-bg-color);
          }
          .device {
            flex: 1;
            height: calc(100% - 60px);
            position: relative;
            padding: 16px;
            @include set_theme_color(background-color, left-menu-bg-color);
          }
        }
      }
    }
  }
}
.el-table-filter {
  border: 1px solid #606266;
  border-radius: 2px;
  background-color: #0d121c;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 2px 0;
}
</style>